var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoAssociation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "#01344F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.01 19.6H32.4447L21.1194 45.85H26.3626L28.2763 40.6H40.1783L42.0921 45.85H47.3353L36.01 19.6ZM29.7706 36.6625L34.2273 24.85L38.684 36.6625H29.7706ZM48.3839 57.4L52.5784 61.6H39.4705V48.475L44.7137 53.725C50.9793 50.0763 55.2 43.0938 55.2 35.35C55.2 23.7738 45.7885 14.35 34.2273 14.35C22.6661 14.35 13.2546 23.7738 13.2546 35.35C13.2546 43.0938 17.4754 49.8663 23.741 53.515V59.395C14.4868 55.3263 8.01147 46.1125 8.01147 35.35C8.01147 20.9125 19.8086 9.10001 34.2273 9.10001C48.6461 9.10001 60.4432 20.9125 60.4432 35.35C60.4432 44.6163 55.6457 52.7275 48.3839 57.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAssociation);
export default __webpack_public_path__ + "static/media/autoAssociation.e952736d483707cdb258edb2a38d96f9.svg";
export { ForwardRef as ReactComponent };